import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { ToolsService } from '../../../services/tools/tools.service';
import { Column } from '../../interfaces/column.interface';
import { TermsDataService, TermsColumnsService } from '../../services';
import { DialogTermFormComponent } from './term-form/term-form.component';
import { DialogTermDetailsComponent } from './term-details/term-details.component';
import { Term, TermsResult } from '../../interfaces';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
  providers: [MessageService, ConfirmationService, DialogService],
})
export class TermsComponent implements OnInit, OnDestroy {

  private termAddDialog: DynamicDialogRef = new DynamicDialogRef();
  private termEditDialog: DynamicDialogRef = new DynamicDialogRef();
  private termDetailsDialog: DynamicDialogRef = new DynamicDialogRef();
  public termsToDelete: Term = {};
  public terms: Term[] = [];
  public columns: Column[] = [];
  public isLoading: boolean = false;
  public isInitialized: boolean = false;
  private _selectedColumns: Column[] = [];
  public selectedApplication: any = null; // Application sélectionnée
  public filteredTerms:any = []; // Liste filtrée
  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
    private router: Router,
    private dialogService: DialogService,
    private messageService: MessageService,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private termsDataService: TermsDataService,
    private termsColumnsService: TermsColumnsService,
  ) {
  }

  ngOnInit(): void {
    this.isInitialized = true;
    this.titleService.setTitle('Terms - Management');
    this.primengConfig.ripple = true;
    this.getTerms();
    this.getTermsByApp();

    let jsonAuth = localStorage.getItem(AuthService.ATUH_STORAGE_KEY);

    if (jsonAuth !== null) {
      const data = JSON.parse(jsonAuth);
      console.log('this.selectedApplication', data.application[0].id)
      this.selectedApplication = data.application[0].id
      // this.token = data.token;
    } else {
      // this.token = null;
    }
    if (this.selectedApplication != 7) {
      console.log('this.selectedApplication', this.selectedApplication)

    
      this.filteredTerms = this.filteredTerms
      console.log('this.filteredTerms', this.filteredTerms)


    } else {
      this.termsDataService.getTerms().subscribe((response: TermsResult|any) => {
        this.isLoading = false;
        if (response !== null) {
          this.setColumns();
          this.terms = response.success.data;
          this.filteredTerms = this.terms

        }
      }, (error: any) => {;
        this.isLoading = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('UI.ERROR'), detail: this.translate.instant('UI.ARTICLESNOTLOADED')});
      });
      console.log('this.filteredTerms', this.terms)


    }
  }

  ngOnDestroy(): void {
    this.isInitialized = false;
  }

  getTerms(): void {
    this.isLoading = true;
    if (!this.isInitialized) {
      return;
    }
    this.termsDataService.getTerms().subscribe((response: TermsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.setColumns();
        this.terms = response.success.data;
      }
    }, (error: any) => {;
      this.isLoading = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('UI.ERROR'), detail: this.translate.instant('UI.ARTICLESNOTLOADED')});
    });
  }

  getTermsByApp(): void {
    this.isLoading = true;
    if (!this.isInitialized) {
      return;
    }
    this.termsDataService.getTermsByApp().subscribe((response: TermsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.setColumns();
        this.filteredTerms = response.success.data;
      }
    }, (error: any) => {;
      this.isLoading = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('UI.ERROR'), detail: this.translate.instant('UI.ARTICLESNOTLOADED')});
    });
  }


  setColumns() {
    if (this.columns.length > 0) {
      return;
    }
    this.columns = this.termsColumnsService.getColumns();
    for (let i = 0; i < this.columns.length; i++) {
      if (this.columns[i].show) {
        this._selectedColumns.push(this.columns[i]);
      }
    }
  }

  @Input()
  get selectedColumns(): any[] {
      return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
      // restore original order
      this._selectedColumns = this.columns.filter((col: any) => val.includes(col));
      this.updateColumns();
  }

  updateColumns() {
    for (let i = 0; i < this.columns.length; i++) {
      const show = this._selectedColumns.includes(this.columns[i]);
      this.columns[i].show = show;
      this.navigation.setParamValue('posts.' + this.columns[i].field + '.showFiled', show);
    }
  }

  exportPdf() {
    ToolsService.exportPdf(this.terms, this.columns, 'Terms');
  }

  exportExcel() {
    ToolsService.exportExcel(this.terms, this.columns, 'Terms');
  }

  exportCsv() {
    ToolsService.exportCsv(this.terms, this.columns, 'Terms');
  }

  refresh() {
    this.getTerms();
  }

  termAdd(): void {
    if (!this.navigation.getParamValue('posts.addInDialog', true)) {
      this.router.navigate(['/terms/add']);
      return;
    }
    this.termAddDialog = this.dialogService.open(DialogTermFormComponent, {
      header: '', // this.translate.instant('NEWARTICLE'),
      width: '80%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1000,
      data: {
        mode: 'add',
        post: {id: null},
      },
    });

    this.termAddDialog.onClose.subscribe((response: any) => {
      if (response && response.refresh) {
        this.messageService.clear();
        this.messageService.add({severity: 'success', summary: 'Success', detail: 'term added'});
        this.getTerms();
      }
    });
  }

  termEdit(term: Term): void {
    if (!this.navigation.getParamValue('posts.editInDialog', true)) {
      this.router.navigate(['/terms/edit/' + term.id]);
      return;
    }
    this.termEditDialog = this.dialogService.open(DialogTermFormComponent, {
      header: '', // this.translate.instant('EDITARTICLE') + ' ' + term.title,
      width: '70%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1000,
      data: {
        mode: 'edit',
        post: term,
       // users: this.postsColumnsService.users,
      },
    });

    this.termEditDialog.onClose.subscribe((response: any) => {
      if (response && response.refresh) {
        this.messageService.clear();
        this.messageService.add({severity: 'success', summary: 'Success', detail: 'term updated'});
        this.getTerms();
      }
    });
  }

  termDetails(term: Term): void {
    if (!this.navigation.getParamValue('posts.detailsInDialog', true)) {
      this.router.navigate(['/terms/details/' + term.id]);
      return;
    }
    this.termDetailsDialog = this.dialogService.open(DialogTermDetailsComponent, {
      width: '70%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1000,
      data: {
        post: term,
      }
    });
  }

  termDelete(term: Term): void {
    this.termsToDelete = term;
    this.messageService.clear();
    this.messageService.add({
      key: 'postDelete',
      sticky: true,
      severity: 'warn',
      summary: 'Are you sure you want delete ' + term.content + ' ?',
      detail: 'Confirm to proceed'
    });
  }

  onDeleteConfirm(): void {
    this.termsDataService.deleteTerm(this.termsToDelete).subscribe((res: any) => {
      this.messageService.clear();
      this.messageService.add({severity: 'success', summary: 'Success', detail: 'Term deleted'});
      this.getTerms();
    }, (error: any) => {
      this.messageService.clear();
      this.messageService.add({severity: 'error', summary: 'Error', detail: 'Term not deleted'});
    });
  }

  onDeleteReject(): void {
    this.termsToDelete = {};
    this.messageService.clear('postDelete');
  }

}
